import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { IonRefresher, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import { GenericTableAnagraphTable } from "src/model/class/general classes/generic-table-anagraph-table";
import { ReportHTML } from "src/model/class/general classes/report-html";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { AlertService } from "src/service/alert.service";
import { EventService } from "src/service/event.service";
import { LoaderService } from "src/service/loader.service";
import { LoggerService } from "src/service/logger.service";
import { MqttClientService } from "src/service/mqtt-client.service";
import { NetworkService } from "src/service/network.service";
import { ReporthtmlService } from "src/service/reporthtml.service";
import { SystemRouterService } from "src/service/system-router.service";

@Component({
    selector: "app-reporthtml-list",
    templateUrl: "./reporthtml-list.component.html",
    styleUrls: ["./reporthtml-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReporthtmlListComponent
  extends GenericTableAnagraphTable
  implements OnInit, iEvent {
  @Input("allowEdit") allowEdit: boolean = true;
  @Input("allowInsert") allowInsert: boolean = true;
  @Input("openInPopup") openInPopup: boolean = false;

  private _logContext: string = "Reporthtml-list.component";

  private _reportHTMLSubscription: Subscription = null;
  private _lblNew: string = "";

  private _translateSubscription: Subscription = null;
  private _networkServiceSubscription: Subscription = null;

  private _intervalTimer: number = 4000;

  /**
   * Flag value; if the ionic-refesher component has been activated, it is set to TRUE; otherwise, it is set to FALSE.
   *
   * It is useful to manage the reporthtml-list re-initialisation caused by the ionic-refesher activation; in that case, the refresher is immediately
   * completed.
   */
  private _isRefreshOnGoing: boolean = false;

  private _currentlySelectedReportID: number = -1;

  public lblFunctionalityNotSupported: string = "Funzionalità non supportata";
  public isFunctionalityNotImplemented: boolean = false;

  /**Flag value; if the skeleton component MUST be showed, it is set to TRUE, otherwise, to FALSE. */
  public isSpookySkeleton: boolean = false;

  public _eventSubscriptions: Array<Subscription> = null;
  public event: any;

  public reportHTMLList: Array<ReportHTML> = new Array<ReportHTML>();

  /**Flag value; if the "reporthtml-list" has been properly initialised from public Observable, it is set to TRUE; otherwise it is set to FALSE.
   *
   * NOTE: Generally, when it is set to FALSE, the page should display the "skeleton" list
   */
  public isReportsHTMLInitialized: boolean = false;

  public searchText: string = "";
  //public isScheduleLoading: boolean = true;
  public showErrorContent: boolean = false;
  public lblNoContentText: string = "";
  public lblSearchBarPlaceholder: string = "";

  public connectionType = ConnectionType;
  public currentConnectionType: ConnectionType = ConnectionType.NONE;

  public toolBarColor: string = "primary";

  @ViewChild("refresherRef", { static: false }) refresherRef: IonRefresher;

  constructor(
    private _reportHTMLService: ReporthtmlService,
    private _alertService: AlertService,
    private _loaderController: LoaderService,
    private _eventService: EventService,
    private _translateService: TranslateService,
    private _modalController: ModalController,
    private _networkService: NetworkService,
    private _mqttService: MqttClientService,
    private _systemRouterService: SystemRouterService,
    private _loggerService: LoggerService
  ) {
    super();
  }

  ngOnInit() {
    this._isRefreshOnGoing = false;
    this.isSpookySkeleton = false;
    this.isReportsHTMLInitialized = false;

    this.subscribeEvents();

    this.loadTranslation();
    this.subscribeTranslationEvent();

    this.subscribeNetworkServiceData();

    this.subscribeReportHTMLService();

    this.searchText = "";
    this._reportHTMLService.Init();
  }

  ngOnDestroy() {
    this._reportHTMLSubscription.unsubscribe();

    this._translateSubscription.unsubscribe();

    this._networkServiceSubscription.unsubscribe();

    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        if (this.openInPopup) {
          this._modalController.dismiss();
        }
      })
    );

    this._eventSubscriptions.push(
      this._eventService.OnReportHTMLChange.subscribe(
        async (idReportChanged_ClientID: string) => {
          this._loggerService.log(LogLevel.LOG_INFO, this._logContext, "_eventService", "OnReportHTMLChange", "Received OnReportHTMLChange from client: " + idReportChanged_ClientID);

          const idReportChanged_ClientIDSplit =
            idReportChanged_ClientID.split("|");
          if (idReportChanged_ClientIDSplit[1] !== this._mqttService.clientID) {

            const changedReportID = parseInt(idReportChanged_ClientIDSplit[0]);

            if (this._currentlySelectedReportID === changedReportID) {
              await this._alertService.presentAlertDataUpdated();

              this.changedSelected.emit(
                this.reportHTMLList.find((report) => report.id === changedReportID)
              );
            }

          }
        }
      )
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  private subscribeReportHTMLService() {
    var timer = setTimeout(() => {
      this.handlePeculiarApiResponseError();
    }, this._intervalTimer);
    this._reportHTMLSubscription = this._reportHTMLService.reportHTMLlist
      //We ignore the "null" emission when log-out is executed
      .pipe(
        filter((res) => res !== null),
        map((listReport) => {
          return listReport || [];
        })
      )
      .subscribe(async (listReportHTML: Array<ReportHTML>) => {

        clearTimeout(timer);
        if (this._reportHTMLService.isErrorInGetReportHTMLListAPIRequest) {
          this.isReportsHTMLInitialized = false;

          if (this._isRefreshOnGoing) {
            await this.refresherRef.complete();
            this.isSpookySkeleton = false;
            this._isRefreshOnGoing = false;
          }
          this.handlePeculiarApiResponseError();
        } else {
          this._loggerService.log(LogLevel.LOG_INFO, this._logContext, "_reportHTMLService", "reportHTMLlist", "All right");

          this.reportHTMLList = listReportHTML;

          this.isReportsHTMLInitialized = true;
          this.showErrorContent = false;

          if (this._isRefreshOnGoing) {
            setTimeout(async () => {
              this.refresherRef.disabled = true;
              await this.refresherRef.complete();

              /* IMPORTANT WORKAROUND  */
              /*The temporised toggling of refresher's property "disabled" value is necessary in order to side-step the bug 
              in which, after its first activation, the refresher is randomly activated each time the user "scroll down" the page.
              */
              setTimeout(() => {
                this.refresherRef.disabled = false;
              }, 100);

              this.isSpookySkeleton = false;
              this._isRefreshOnGoing = false;
            }, 500);
          }
        }
      });
  }

  private async handleApiResponseError(): Promise<void> {

    this.reportHTMLList = new Array<ReportHTML>();
    this.showErrorContent = true;

  }

  /**
   * Subscribe to the public Observable of "NetworkService", which emits each time the connection change of type/state. A local property is changed to
   * reflect the new value.
   */
  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;

          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType
          );
        }
      );
  }

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get([
        "dictionary.newFemale",
        "dictionary.noReportHTMLFound",
        "dictionary.searchReportHTML",
        "dictionary.functionalityNotSupported",
      ])
      .subscribe((translation) => {
        this._lblNew = translation["dictionary.newFemale"];
        this.lblNoContentText = translation["dictionary.noReportHTMLFound"];
        this.lblSearchBarPlaceholder =
          translation["dictionary.searchReportHTML"];
        this.lblFunctionalityNotSupported =
          translation["dictionary.functionalityNotSupported"];
      });
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion

  public onRequestEditReport($event) {
    this._currentlySelectedReportID = parseInt($event);

    if (!this.openInPopup) {

      this.changedSelected.emit(
        this.reportHTMLList.find((report) => report.id === parseInt($event))
      );
    } else {
      this._loggerService.log(LogLevel.LOG_INFO, this._logContext, this._logContext, "onRequestEditReport()", "Opened in pop-up - proceed");
      this._modalController.dismiss(parseInt($event));
    }
  }

  public onCloseModal() {
    this._modalController.dismiss();
  }



  /** GF: action to execute when the refresh is called */
  public async doRefresh() {

    this._reportHTMLService.needToInitialize = true;
    this._isRefreshOnGoing = true;
    this.isSpookySkeleton = true;

    this._reportHTMLService.Init();
  }

  /**
   * Force reload data after "Something went wrong" button refresh click
   */
  public forceReloadData() {

    this._reportHTMLService.reloadServiceData();
  }

  /**
   *
   *  Insert new schedule when user press plus button on header. It assign a default name to schedule and it set it to active.
   *  If API schedule creation end successfully than redirect to scheudle editor route (/schedules/{idNewSchedule}) otherwise show error message.
   *  During creation schedule process, it show a loader popup for entertaining user and don't allow creation of new schedule in same time.
   *
   *
   */
  public async onRequestNew() {
    await this._loaderController.presentLoaderWaiting();

    try {
      let newReportHTML: ReportHTML = new ReportHTML();

      newReportHTML.description = this._lblNew;

      newReportHTML = await this._reportHTMLService.InsertReportHTML(
        newReportHTML
      );

      this._systemRouterService.navigateToSpecificReportHTML(newReportHTML.id);

      await this._loaderController.dismissLoaderWaiting();
    } catch (error) {
      this._loggerService.log(LogLevel.LOG_ERROR, this._logContext, this._logContext, "onRequestNew()", "ERROR: " + error.message);
      await this._loaderController.dismissLoaderWaiting();

      await this._alertService.presentAlertSomethingWrong();
    }
  }

  /**
   * Handle errors in api call which require peculiar reactions from the page; this includes cases where the error is propagated through subject.error()
   * @param error
   */
  private async handlePeculiarApiResponseError() {
    if (this._reportHTMLService.isErrorNotSupported) {
      this.isFunctionalityNotImplemented = true;
      await this._loaderController.dismissLoaderWaiting();
    } else {
      this.handleApiResponseError();
    }
  }
}
